import script from "./SpinnerLoaderButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerLoaderButton.vue?vue&type=script&setup=true&lang=ts"

import "./SpinnerLoaderButton.vue?vue&type=style&index=0&id=b63f9ec2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b63f9ec2"]])

export default __exports__